// document.addEventListener("DOMContentLoaded", function() {
//     document.getElementById("metaDataTab1").style.display = "block";

//     document.querySelectorAll('.product-form__label').forEach(function(label) {
//         label.addEventListener('click', function() {
//             var variantId = this.getAttribute('as-variant-id');
//             document.querySelectorAll(".tab").forEach(tab => tab.style.display = "none");

//             switch (variantId) {
//                 case '10K White Gold':
//                     document.getElementById("metaDataTab1").style.display = "block"; 
//                     break;
//                 case '10K Yellow Gold':
//                     document.getElementById("metaDataTab2").style.display = "block"; 
//                     break;
//                 case '10K Rose Gold':
//                     document.getElementById("metaDataTab3").style.display = "block"; 
//                     break;
//                 case '14K White Gold':
//                     document.getElementById("metaDataTab4").style.display = "block"; 
//                     break;
//                 case '14K Yellow Gold':
//                     document.getElementById("metaDataTab5").style.display = "block"; 
//                     break;
//                 case '14K Rose Gold':
//                     document.getElementById("metaDataTab6").style.display = "block"; 
//                     break;
//                 case '18K White Gold':
//                     document.getElementById("metaDataTab7").style.display = "block"; 
//                     break;
//                 case '18K Yellow Gold':
//                     document.getElementById("metaDataTab8").style.display = "block"; 
//                     break;
//                 case '18K Rose Gold':
//                     document.getElementById("metaDataTab9").style.display = "block"; 
//                     break;
//                 case 'Platinum':
//                     document.getElementById("metaDataTab10").style.display = "block"; 
//                     break;
//                 default:
//                     document.querySelectorAll(".tab").forEach(tab => tab.style.display = "none");
//             }
//         });
//     });
// });

// document.querySelectorAll(".asVariantColor").forEach(span => {
//     let value = span.textContent.trim();

//     if (value.includes("White Gold")) {
//         span.classList.add("as-variant-white");
//     } else if (value.includes("Yellow Gold")) {
//         span.classList.add("as-variant-yellow");
//     } else if (value.includes("Rose Gold")) {
//         span.classList.add("as-variant-rose");
//     } else if (value.includes("Platinum")) {
//         span.classList.add("as-variant-platinum");
//     }

//     if (value === "10K White Gold") {
//         span.classList.add("white-gold-active");
//     }

//     span.addEventListener("click", () => {
//         document.querySelectorAll(".asVariantColor").forEach(el => {
//             el.classList.remove("white-gold-active", "yellow-gold-active", "rose-gold-active", "platinum-active");
//         });

//         if (value.includes("White Gold")) {
//             span.classList.add("white-gold-active");
//         } else if (value.includes("Yellow Gold")) {
//             span.classList.add("yellow-gold-active");
//         } else if (value.includes("Rose Gold")) {
//             span.classList.add("rose-gold-active");
//         } else if (value.includes("Platinum")) {
//             span.classList.add("platinum-active");
//         }
//     });
// });


// =======================================================================================================================
// NEW CODE 19/01/2026



document.addEventListener("DOMContentLoaded", function() {
    
    // 1. Initial State: Display the first tab (e.g., 10K White Gold)
    function showDefaultTab() {
        const allTabs = document.querySelectorAll(".tab");
        allTabs.forEach(tab => tab.style.display = "none");
        
        // Check which variant is checked on load
        const checkedInput = document.querySelector('.product-form__radio:checked');
        if (checkedInput) {
            const label = document.querySelector(`label[for="${checkedInput.id}"]`);
            if (label) {
                const variantName = label.getAttribute('as-variant-id');
                updateTabDisplay(variantName);
            }
        } else {
            // Fallback to Tab 1 if nothing is selected
            if(document.getElementById("metaDataTab1")) document.getElementById("metaDataTab1").style.display = "block";
        }
    }

    // 2. Helper Function to switch tabs
    function updateTabDisplay(variantId) {
        if (!variantId) return;
        
        document.querySelectorAll(".tab").forEach(tab => tab.style.display = "none");
        
        let targetId = "";
        const name = variantId.trim();

        switch (name) {
            case '10K White Gold':  targetId = "metaDataTab1"; break;
            case '10K Yellow Gold': targetId = "metaDataTab2"; break;
            case '10K Rose Gold':   targetId = "metaDataTab3"; break;
            case '14K White Gold':  targetId = "metaDataTab4"; break;
            case '14K Yellow Gold': targetId = "metaDataTab5"; break;
            case '14K Rose Gold':   targetId = "metaDataTab6"; break;
            case '18K White Gold':  targetId = "metaDataTab7"; break;
            case '18K Yellow Gold': targetId = "metaDataTab8"; break;
            case '18K Rose Gold':   targetId = "metaDataTab9"; break;
            case 'Platinum':        targetId = "metaDataTab10"; break;
        }

        const targetTab = document.getElementById(targetId);
        if (targetTab) targetTab.style.display = "block";
    }

    // 3. Click Event Listener
    document.body.addEventListener('click', function(e) {
        const label = e.target.closest('.product-form__label');
        if (!label) return;

        const variantName = label.getAttribute('as-variant-id');
        updateTabDisplay(variantName);

        // Manage Active Classes
        document.querySelectorAll(".asVariantColor").forEach(span => {
            span.classList.remove("white-gold-active", "yellow-gold-active", "rose-gold-active", "platinum-active");
        });

        const activeSpan = label.querySelector(".asVariantColor");
        if (activeSpan && variantName) {
            const lowVal = variantName.toLowerCase();
            if (lowVal.includes("white gold")) activeSpan.classList.add("white-gold-active");
            else if (lowVal.includes("yellow gold")) activeSpan.classList.add("yellow-gold-active");
            else if (lowVal.includes("rose gold")) activeSpan.classList.add("rose-gold-active");
            else if (lowVal.includes("platinum")) activeSpan.classList.add("platinum-active");
        }
    });

    showDefaultTab();
});